'use client';

import { Badge } from '@repo/ui';
import { Ban } from 'lucide-react';
import type { JSX } from 'react';

interface IPipelineStepRejectedBadgeProps {
  count: number;
}

export function PipelineStepRejectedBadge({ count }: IPipelineStepRejectedBadgeProps): JSX.Element {
  if (count === 0) {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        -
      </Badge>
    );
  }

  return (
    <Badge variant="destructive" className="gap-1">
      <Ban className="size-3" />
      {count}
    </Badge>
  );
}
